module.exports = "/_next/static/images/hartford-ct-a2c58b7e9afdfab4fecd466093f6ae85.jpg";